import type { AttensiFetchError } from './AttensiFetchError'
import { ERROR_NAME } from './constants'

export function isAttensiFetchError(error: any): error is AttensiFetchError {
  return error instanceof Error && error.name === ERROR_NAME
}
